import { render, staticRenderFns } from "./CollectionHero.vue?vue&type=template&id=16ed99a0&scoped=true&lang=pug&"
import script from "./CollectionHero.vue?vue&type=script&lang=js&"
export * from "./CollectionHero.vue?vue&type=script&lang=js&"
import style0 from "./CollectionHero.vue?vue&type=style&index=0&id=16ed99a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed99a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ed99a0')) {
      api.createRecord('16ed99a0', component.options)
    } else {
      api.reload('16ed99a0', component.options)
    }
    module.hot.accept("./CollectionHero.vue?vue&type=template&id=16ed99a0&scoped=true&lang=pug&", function () {
      api.rerender('16ed99a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionHero.vue"
export default component.exports